(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function init(root) {
      if (root.__ticker) return;
      root.__ticker = true;
      var track = root.querySelector('.ticker__track');
      var btn = root.querySelector('[data-ticker-toggle]');
      /* Constant reading speed whatever the message length: duration = width / speed. */
      function pace() {
        var speed = Math.max(10, parseFloat(root.getAttribute('data-speed')) || 40);
        root.style.setProperty('--ticker-duration', (track.scrollWidth / speed).toFixed(1) + 's');
      }
      pace();
      window.addEventListener('resize', pace, { passive: true });
      if (btn) btn.addEventListener('click', function () {
        var paused = !root.hasAttribute('data-paused');
        root.toggleAttribute('data-paused', paused);
        btn.setAttribute('aria-pressed', String(paused));
        btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
        btn.querySelector('[data-icon-pause]').hidden = paused;
        btn.querySelector('[data-icon-play]').hidden = !paused;
      });
    }
    function boot(scope) { Array.prototype.forEach.call(scope.querySelectorAll('[data-ticker]'), init); }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["armour-anatomy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    /* Where each callout leaves the drawing, in viewBox units. */
    var ANCHOR = {
      helmet: [187, 44], pauldrons: [231, 130], chest: [189, 156], bracers: [233, 248],
      gauntlets: [245, 312], thighs: [188, 320], greaves: [182, 410], sword: [289, 230]
    };
    var VB_W = 300, VB_H = 520;

    function init(root) {
      if (root.__anat) return;
      root.__anat = true;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-anat-tab]'));
      var zones = Array.prototype.slice.call(root.querySelectorAll('[data-anat-zone]'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-anat-card]'));
      var svg = root.querySelector('.anat__svg');
      var info = root.querySelector('[data-anat-info]');
      var lead = root.querySelector('[data-anat-lead]');
      var line = root.querySelector('[data-anat-lead-line]');
      var dot = root.querySelector('[data-anat-lead-dot]');
      if (!tabs.length || !cards.length) return;
      var current = null;

      /* Level with the piece name, ending on the details card's left edge.
         Null when the two are stacked, where a leader would point at nothing. */
      function target() {
        var s = svg.getBoundingClientRect(), p = info.getBoundingClientRect();
        if (!s.width || p.left < s.right) return null;
        var card = info.querySelector('[data-anat-card]:not([hidden]) .anat__name');
        var b = card ? card.getBoundingClientRect() : p;
        return {
          x: (p.left - s.left) / s.width * VB_W,
          y: Math.max(12, Math.min(VB_H - 12, (b.top + b.height / 2 - s.top) / s.height * VB_H))
        };
      }

      function drawLead(zone, animate) {
        var a = ANCHOR[zone], t = a && target();
        if (!t) { lead.removeAttribute('data-on'); return; }
        var ex = Math.max(a[0] + 20, Math.min(t.x - 24, 300));
        line.setAttribute('d', 'M' + a[0] + ' ' + a[1] + 'L' + ex.toFixed(1) + ' ' + t.y.toFixed(1) + 'L' + t.x.toFixed(1) + ' ' + t.y.toFixed(1));
        dot.setAttribute('cx', a[0]);
        dot.setAttribute('cy', a[1]);
        var len = 300;
        try { len = Math.ceil(line.getTotalLength()); } catch (e) {}
        line.style.setProperty('--len', len);
        if (animate && !reduced.matches) {
          lead.setAttribute('data-draw', '');
          void line.getBoundingClientRect();
          lead.removeAttribute('data-draw');
        }
        lead.setAttribute('data-on', '');
      }

      /* Keyboard changes are instant; only pointer choices draw the leader on. */
      function select(zone, opts) {
        opts = opts || {};
        if (!zone || zone === current) return;
        cards.forEach(function (c) { c.hidden = c.getAttribute('data-anat-card') !== zone; });
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-anat-tab') === zone;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          if (on && opts.focus) t.focus();
          if (on && opts.reveal && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        zones.forEach(function (z) {
          z.toggleAttribute('data-on', z.getAttribute('data-anat-zone') === zone);
        });
        current = zone;
        drawLead(zone, !!opts.animate);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { select(t.getAttribute('data-anat-tab'), { animate: true }); });
      });
      root.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        select(tabs[n].getAttribute('data-anat-tab'), { focus: true, reveal: true });
      });
      zones.forEach(function (z) {
        var zone = z.getAttribute('data-anat-zone');
        z.addEventListener('click', function () { select(zone, { animate: true, reveal: true }); });
        z.addEventListener('pointerenter', function () { if (fine.matches) select(zone, { animate: true, reveal: true }); });
      });

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { drawLead(current, false); }, 120);
      });

      select(tabs[0].getAttribute('data-anat-tab'));
    }

    function boot(scope) { Array.prototype.forEach.call(scope.querySelectorAll('[data-anat]'), init); }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foam-lab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

    /* The catalogue's real numbers for the three sheet grades. Prices are not
       set yet, so none appear here. */
    var DENSITY = {
      20: { name: 'Low density EVA foam', sheet: [1000, 1000], mm: [5, 8, 10] },
      40: { name: 'High density EVA foam', sheet: [1000, 1000], mm: [2, 4, 6, 8, 10, 15] },
      70: { name: 'Ultra high density EVA foam', sheet: [1000, 1150], mm: [3, 5, 8, 10, 15] }
    };

    /* ---------- Finder ---------------------------------------------------- */
    function finder(lab) {
      var root = $('[data-finder]', lab);
      if (!root) return;
      var steps = $$('[data-step]', root);
      var dots = $$('[data-dot]', root);
      var out = $('[data-result]', lab);
      var actions = $('[data-actions]', lab);
      var addBtn = $('[data-finder-add]', lab);
      var link = $('[data-result-link]', lab);
      var baseHref = link ? link.getAttribute('href') : '/collections/all';
      var baseLabel = link ? link.textContent : '';
      var waiting = out ? out.innerHTML : '';
      var T = window.ForgeTheme || {};
      var STR = T.strings || {};
      var answers = {};
      var i = 0;

      var CATALOGUE = (function () {
        var el = $('[data-finder-variants]', lab);
        if (!el) return [];
        try { return (JSON.parse(el.textContent) || {}).items || []; } catch (e) { return []; }
      })();

      function mmOf(t) {
        var m = String(t || '').match(/(\d+(?:\.\d+)?)\s*mm/i);
        return m ? parseFloat(m[1]) : null;
      }
      function productFor(density) {
        return CATALOGUE.filter(function (p) { return Number(p.density) === Number(density); })[0] || null;
      }
      function variantFor(density, mm) {
        var p = productFor(density);
        if (!p) return null;
        var v = (p.variants || []).filter(function (x) { return mmOf(x.option) === Number(mm); })[0];
        return v ? { product: p, variant: v } : null;
      }

      function show(n) {
        i = Math.max(0, Math.min(steps.length - 1, n));
        steps.forEach(function (s, k) { s.hidden = k !== i; });
        dots.forEach(function (d, k) { d.setAttribute('data-on', String(k <= i)); });
        var h = steps[i].querySelector('legend');
        if (h && n > 0) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }

      function tell(density) {
        lab.dispatchEvent(new CustomEvent('forge:pick', { detail: { density: density } }));
      }

      var S = (function () {
        var el = $('[data-finder-strings]', lab);
        try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
      })();
      /* Shopify's t filter HTML-escapes translations (it's becomes it&#39;s), and these
         strings are written with textContent, so decode the entities once. */
      var decoder = document.createElement('textarea');
      function s(k) { decoder.innerHTML = S[k] || ''; return decoder.value; }
      function row(dt, dd) { return '<div class="spec__row"><dt>' + dt + '</dt><dd>' + dd + '</dd></div>'; }

      function decide() {
        var build = answers.build, shape = answers.shape, size = answers.size;
        var d = 40, mm = 6, why = [];

        if (build === 'soft') { d = 20; mm = 10; why.push(s('why_soft')); }
        else if (build === 'prop') { d = 70; mm = 10; why.push(s('why_prop')); }
        else if (build === 'detail') { d = 40; mm = 2; why.push(s('why_detail')); }
        else { why.push(s('why_armour')); }

        if (shape === 'deep' && d === 70) { d = 40; why.push(s('why_deep_down')); }
        if (shape === 'deep' && mm > 6) { mm = 6; why.push(s('why_deep_thin')); }
        if (shape === 'flat' && build === 'armour') { mm = 8; why.push(s('why_flat')); }
        if (size === 'large' && mm < 6 && build !== 'detail') { mm = 6; why.push(s('why_large')); }
        if (size === 'small' && build === 'armour' && mm > 6) { mm = 6; why.push(s('why_small')); }

        var info = DENSITY[d];
        function nearest(list, target) {
          return list.reduce(function (a, b) { return Math.abs(b - target) < Math.abs(a - target) ? b : a; });
        }
        if (info.mm.indexOf(mm) === -1) mm = nearest(info.mm, mm);

        /* Never end on a sold-out sheet: move to the closest thickness on the shelf,
           and if the whole grade is out, offer the restock sign-up instead. */
        var stocked = ((productFor(d) || {}).variants || [])
          .filter(function (v) { return v.available; })
          .map(function (v) { return mmOf(v.option); })
          .filter(function (n) { return n !== null; });
        var allOut = !!productFor(d) && stocked.length === 0;
        if (stocked.length && stocked.indexOf(mm) === -1) {
          why.push(s('why_stock').replace('[mm]', mm));
          mm = nearest(stocked, mm);
        }

        out.innerHTML =
          '<div class="lab__rec">' +
            '<p class="lab__rec-title">' + s('recommended') + ' ' + info.name + ', ' + mm + ' mm.</p>' +
            '<dl class="spec">' +
              row(s('spec_density'), d + ' kg/m&sup3;') +
              row(s('spec_thickness'), mm + ' mm') +
              row(s('spec_sheet'), info.sheet[0] + ' &times; ' + info.sheet[1] + ' mm') +
              row(s('spec_also'), info.mm.join(', ') + ' mm') +
            '</dl>' +
            '<ul class="lab__why">' + why.filter(Boolean).map(function (w) { return '<li>' + w + '</li>'; }).join('') + '</ul>' +
            '<p class="lab__note lab__heat">' + s('heat_' + d) + '</p>' +
          '</div>';

        var product = productFor(d);
        if (link) {
          link.href = product ? product.url : baseHref;
          link.textContent = allOut ? s('restock') : (product ? s('view') + ' ' + info.name : baseLabel);
        }
        if (actions) actions.hidden = false;

        var hit = variantFor(d, mm);
        if (addBtn) {
          if (!hit || allOut) { addBtn.hidden = true; }
          else {
            addBtn.hidden = false;
            addBtn.setAttribute('data-variant', hit.variant.id);
            var ok = !!hit.variant.available;
            addBtn.disabled = !ok;
            addBtn.textContent = ok ? (STR.add_to_cart || 'Add to cart') : (STR.sold_out || 'Sold out');
          }
        }
        tell(d);
      }

      if (addBtn) addBtn.addEventListener('click', function () {
        var id = parseInt(addBtn.getAttribute('data-variant'), 10);
        if (!id || addBtn.disabled) return;
        var routes = T.routes || {};
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = STR.adding || 'Adding…';
        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) { if (T.toast) T.toast(res.json.description || res.json.message || STR.error); return; }
            if (T.Cart) return T.Cart.refresh().then(function () { T.Cart.open(); });
            window.location.href = routes.cart_url;
          })
          .catch(function () { if (T.toast) T.toast(STR.error || 'Something went wrong.'); })
          .then(function () { addBtn.disabled = false; addBtn.textContent = label; });
      });

      $$('[data-answer]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.getAttribute('data-answer');
          answers[group] = btn.getAttribute('data-value');
          $$('[data-answer="' + group + '"]', root).forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          show(i + 1);
          if (i === steps.length - 1) decide();
        });
      });
      $$('[data-back]', root).forEach(function (b) {
        b.addEventListener('click', function () { show(i - 1); });
      });
      var restart = $('[data-restart]', root);
      if (restart) restart.addEventListener('click', function () {
        answers = {};
        $$('[data-answer]', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        if (out) out.innerHTML = waiting;
        if (actions) actions.hidden = true;
        tell(null);
        show(0);
      });

      show(0);
    }

    /* ---------- Squish rig ------------------------------------------------ */
    var LEFT = 8, RIGHT = 192, BOTTOM = 152, TOP = 50, H = BOTTOM - TOP;

    function rig(lab) {
      var root = $('[data-squish]', lab);
      if (!root) return;
      var btn = $('[data-squish-rig]', root);
      var cols = $$('[data-squish-col]', root);

      var samples = cols.map(function (col) {
        var d = parseFloat(col.getAttribute('data-density')) || 40;
        return {
          give: (parseFloat(col.getAttribute('data-give')) || 30) / 100,
          body: $('[data-squish-body]', col),
          crust: $('[data-squish-crust]', col),
          shadow: $('[data-squish-shadow]', col),
          plate: $('[data-squish-plate]', col),
          out: $('[data-squish-readout]', col),
          k: 90 + d * 3.2,           /* stiffer foam springs back faster */
          damp: 11 + d * 0.14,       /* and settles without wobbling */
          c: 0, v: 0
        };
      });

      function py(v, c) { var h = H * (1 - c); return BOTTOM - h + v * h; }
      function f(n) { return n.toFixed(1); }

      function draw(s) {
        var c = s.c, topY = py(0, c);
        var bulge = (RIGHT - LEFT) * c * 0.06;       /* shallow, so it never reads as a barrel */
        var midR = RIGHT + bulge * 2, midL = LEFT - bulge * 2, midY = py(0.5, c);
        var r = 5 + c * 4;
        s.body.setAttribute('d',
          'M' + f(LEFT + r) + ' ' + f(topY) + 'L' + f(RIGHT - r) + ' ' + f(topY) +
          'Q' + f(RIGHT) + ' ' + f(topY) + ' ' + f(RIGHT) + ' ' + f(topY + r) +
          'Q' + f(midR) + ' ' + f(midY) + ' ' + f(RIGHT) + ' ' + f(BOTTOM - r) +
          'Q' + f(RIGHT) + ' ' + f(BOTTOM) + ' ' + f(RIGHT - r) + ' ' + f(BOTTOM) +
          'L' + f(LEFT + r) + ' ' + f(BOTTOM) +
          'Q' + f(LEFT) + ' ' + f(BOTTOM) + ' ' + f(LEFT) + ' ' + f(BOTTOM - r) +
          'Q' + f(midL) + ' ' + f(midY) + ' ' + f(LEFT) + ' ' + f(topY + r) +
          'Q' + f(LEFT) + ' ' + f(topY) + ' ' + f(LEFT + r) + ' ' + f(topY) + 'Z');
        s.shadow.setAttribute('rx', f((RIGHT - LEFT) / 2 + bulge * 1.4));
        s.shadow.setAttribute('opacity', (0.18 + c * 0.5).toFixed(3));
        s.crust.setAttribute('d', 'M' + f(LEFT + r + 2) + ' ' + f(topY + 2.2) + 'L' + f(RIGHT - r - 2) + ' ' + f(topY + 2.2));
        s.plate.setAttribute('transform', 'translate(0 ' + f(topY - 8) + ')');
        s.out.textContent = Math.round(c * 100) + '%';
      }

      function pick(d) {
        var hit = false;
        cols.forEach(function (col) {
          var on = d !== null && parseFloat(col.getAttribute('data-density')) === d;
          if (on) { col.setAttribute('data-pick', ''); hit = true; } else col.removeAttribute('data-pick');
        });
        root.toggleAttribute('data-picked', hit);
        return hit;
      }

      if (reduced.matches) {
        /* Show the answer rather than animate it. */
        samples.forEach(function (s) { s.c = s.give; draw(s); });
        lab.addEventListener('forge:pick', function (e) { pick(e.detail.density); });
        return;
      }

      samples.forEach(draw);
      var pressed = false, load = 0, raf = null, last = 0, demo = null;

      function frame(now) {
        var dt = Math.min(0.05, (now - last) / 1000 || 0.016);
        last = now;
        load += ((pressed ? 1 : 0) - load) * Math.min(1, dt * (pressed ? 6 : 9));
        var moving = false;
        samples.forEach(function (s) {
          var target = load * s.give;
          var a = (target - s.c) * s.k - s.v * s.damp;
          s.v += a * dt;
          s.c += s.v * dt;
          if (s.c < 0) { s.c = 0; s.v = 0; }
          draw(s);
          if (Math.abs(s.v) > 0.002 || Math.abs(target - s.c) > 0.0008) moving = true;
        });
        raf = (moving || load > 0.001) ? requestAnimationFrame(frame) : null;
      }
      function start() { if (raf) return; last = performance.now(); raf = requestAnimationFrame(frame); }
      function press(e) { if (e && e.cancelable) e.preventDefault(); pressed = true; start(); }
      function release() { pressed = false; start(); }

      btn.addEventListener('pointerdown', press);
      window.addEventListener('pointerup', release);
      window.addEventListener('pointercancel', release);
      btn.addEventListener('pointerleave', release);
      btn.addEventListener('keydown', function (e) {
        if (e.key !== ' ' && e.key !== 'Enter') return;
        e.preventDefault();
        if (!e.repeat) press();
      });
      btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') release(); });
      btn.addEventListener('blur', release);

      /* A reply to the finder: flag the grade and press once. Not a loop. */
      lab.addEventListener('forge:pick', function (e) {
        if (!pick(e.detail.density)) return;
        pressed = true; start();
        clearTimeout(demo);
        demo = setTimeout(release, 900);
      });
    }

    function init(scope) {
      $$('[data-lab]', scope).forEach(function (lab) {
        if (lab.__forgeLab) return;
        lab.__forgeLab = true;
        rig(lab);
        finder(lab);
      });
    }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { init(document); }) : init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-addons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function money(cents) {
      var T = window.ForgeTheme || {};
      var fmt = T.moneyFormat || '{{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    function init(root) {
      if (root.__addons) return;
      root.__addons = true;
      var checks = Array.prototype.slice.call(root.querySelectorAll('[data-addon]'));
      var countEl = root.querySelector('[data-addon-count]');
      var totalEl = root.querySelector('[data-addon-total]');
      var btn = root.querySelector('[data-addon-add]');
      var label = btn.textContent;

      function chosen() { return checks.filter(function (c) { return c.checked && !c.disabled; }); }
      function sync() {
        var picked = chosen();
        var total = picked.reduce(function (sum, c) { return sum + (parseInt(c.getAttribute('data-price'), 10) || 0); }, 0);
        countEl.textContent = picked.length;
        totalEl.textContent = money(total);
        btn.setAttribute('aria-disabled', picked.length ? 'false' : 'true');
        /* The count and total only mean something once an item is ticked. */
        root.querySelector('[data-addon-sum]').hidden = !picked.length;
        totalEl.hidden = !picked.length;
      }
      checks.forEach(function (c) { c.addEventListener('change', sync); });

      btn.addEventListener('click', function () {
        var picked = chosen();
        if (!picked.length) return;
        var T = window.ForgeTheme || {};
        var strings = T.strings || {};
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = strings.adding || 'Adding';
        fetch((T.routes || {}).cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: picked.map(function (c) { return { id: parseInt(c.value, 10), quantity: 1 }; }) })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) { if (T.toast) T.toast(res.json.description || res.json.message || strings.error); return; }
            picked.forEach(function (c) { c.checked = false; });
            if (T.Cart) return T.Cart.refresh().then(function () { if (T.toast) T.toast(strings.added); T.Cart.open(); });
          })
          .catch(function () { if (T.toast) T.toast(strings.error); })
          .then(function () { btn.textContent = label; sync(); });
      });
      sync();
    }

    function boot(scope) { Array.prototype.forEach.call(scope.querySelectorAll('[data-addons]'), init); }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(header) {
      if (header.__search) return;
      header.__search = true;
      var trigger = header.querySelector('[data-search-open]');
      var panel = header.querySelector('[data-search]');
      var scrim = header.querySelector('[data-search-scrim]');
      var input = header.querySelector('[data-search-input]');
      var results = header.querySelector('[data-search-results]');
      var closeBtn = header.querySelector('[data-search-close]');
      if (!trigger || !panel || !input) return;

      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', 'false');
      var timer = null, controller = null, hideTimer = null;

      function open() {
        clearTimeout(hideTimer);
        var burger = document.querySelector('[data-burger][aria-expanded="true"]');
        if (burger) burger.click();
        panel.hidden = false;
        scrim.hidden = false;
        void panel.offsetWidth;
        panel.setAttribute('data-open', 'true');
        scrim.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        input.focus();
        if (input.value) input.select();
      }

      function close(returnFocus) {
        if (panel.getAttribute('data-open') !== 'true') return;
        panel.setAttribute('data-open', 'false');
        scrim.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
        hideTimer = setTimeout(function () { panel.hidden = true; scrim.hidden = true; }, reduced.matches ? 0 : 200);
        if (returnFocus) trigger.focus();
      }

      function render(q) {
        if (controller) controller.abort();
        if (!q) { results.innerHTML = ''; return; }
        controller = new AbortController();
        var url = panel.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var body = doc.querySelector('[data-predictive]');
            results.innerHTML = body ? body.innerHTML : '';
          })
          .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        panel.getAttribute('data-open') === 'true' ? close(true) : open();
      });
      closeBtn.addEventListener('click', function () { close(true); });
      scrim.addEventListener('click', function () { close(false); });
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { render(q); }, 180);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.getAttribute('data-open') === 'true') close(true);
      });
    }

    // Dropdowns. Desktop only: below the nav breakpoint the panel is always
    // open inside the drawer, so there is nothing to toggle.
    var desktop = window.matchMedia('(min-width: 900px)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    function initMenus(header) {
      if (header.__menus) return;
      header.__menus = true;
      var items = Array.prototype.slice.call(header.querySelectorAll('[data-menu]'));
      if (!items.length) return;

      function setOpen(item, open) {
        item.setAttribute('data-open', open ? 'true' : 'false');
        item.querySelector('[data-menu-btn]').setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function closeAll(except) {
        items.forEach(function (i) { if (i !== except) setOpen(i, false); });
      }

      items.forEach(function (item) {
        var btn = item.querySelector('[data-menu-btn]');
        btn.setAttribute('aria-expanded', 'false');
        item.setAttribute('data-open', 'false');

        item.addEventListener('mouseenter', function () {
          if (!desktop.matches || !fine.matches) return;
          closeAll(item);
          setOpen(item, true);
        });
        item.addEventListener('mouseleave', function () {
          if (!desktop.matches || !fine.matches) return;
          setOpen(item, false);
        });

        btn.addEventListener('click', function (e) {
          if (!desktop.matches) return;             // drawer: the panel is already open
          if (fine.matches) return;                 // mouse: the click follows the link
          if (item.getAttribute('data-open') !== 'true') {
            e.preventDefault();                     // first tap opens, second follows
            closeAll(item);
            setOpen(item, true);
          }
        });

        // Keyboard: the panel follows focus in and out of the item.
        item.addEventListener('focusin', function () {
          if (!desktop.matches) return;
          closeAll(item);
          setOpen(item, true);
        });
        item.addEventListener('focusout', function (e) {
          if (!desktop.matches) return;
          if (!item.contains(e.relatedTarget)) setOpen(item, false);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = items.filter(function (i) { return i.getAttribute('data-open') === 'true'; })[0];
        if (!open) return;
        setOpen(open, false);
        open.querySelector('[data-menu-btn]').focus();
      });

      document.addEventListener('click', function (e) {
        if (!header.contains(e.target)) closeAll(null);
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-header]'), init);
      Array.prototype.forEach.call(scope.querySelectorAll('[data-header]'), initMenus);
    }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-lineup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    function popIn(grid) {
      if (reduced.matches || !('IntersectionObserver' in window)) return;
      grid.setAttribute('data-armed', '');
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        grid.classList.add('is-in');
        io.disconnect();
      }, { threshold: 0.15 });
      io.observe(grid);
    }

    /* Touch screens have no hover: heat the card crossing the middle of the screen. */
    function heatOnScroll(grid) {
      if (fine.matches || !('IntersectionObserver' in window)) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-kit]'));
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) cards.forEach(function (c) { c.classList.toggle('is-hot', c === e.target); });
          else e.target.classList.remove('is-hot');
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    }

    function init(grid, fromEditor) {
      if (grid.__kits) return;
      grid.__kits = true;
      if (!fromEditor) popIn(grid);
      heatOnScroll(grid);
    }

    function boot(scope, fromEditor) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-kits]'), function (g) { init(g, fromEditor); });
    }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target, true); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    'use strict';
    function init(form) {
      if (form.__filters) return;
      form.__filters = true;
      var drops = Array.prototype.slice.call(form.querySelectorAll('[data-fdrop]'));
      /* One panel open at a time. */
      drops.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
      /* Ticking an option applies it straight away. */
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-fauto]')) form.submit();
      });
      /* Close on outside click and on Escape. */
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) drops.forEach(function (d) { d.open = false; });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        drops.forEach(function (d) {
          if (d.open) { d.open = false; d.querySelector('summary').focus(); }
        });
      });
    }
    function boot(scope) { Array.prototype.forEach.call(scope.querySelectorAll('[data-filters]'), init); }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    /* The variant switcher stamps data-state on [data-stock]; the restock form
       and the WhatsApp link both follow that rather than re-deriving it. */
    var root = document.querySelector('[data-product-form]');
    if (!root) return;
    var stock = root.querySelector('[data-stock]');
    var restock = root.querySelector('[data-restock]');
    var vField = root.querySelector('[data-restock-variant]');
    var wa = root.querySelector('[data-wa]');

    function chosen() {
      return Array.prototype.map.call(root.querySelectorAll('[data-opt] input:checked'), function (i) { return i.value; }).join(' / ');
    }
    function sync() {
      if (restock && stock) restock.hidden = stock.getAttribute('data-state') !== 'out';
      if (vField) vField.value = chosen() || vField.value;
    }
    if (stock && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(stock, { attributes: true, attributeFilter: ['data-state'] });
    }
    sync();

    if (wa) {
      wa.addEventListener('click', function () {
        var base = wa.href.split('?')[0];
        var msg = wa.getAttribute('data-wa-message') || document.title;
        var opt = chosen();
        if (opt) msg += ' (' + opt + ')';
        wa.href = base + '?text=' + encodeURIComponent(msg + ' ' + window.location.href);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var MOVE_MS = 480;
    var FIRST_MOVE_MS = 3000;   /* the hero is seen for seconds, so the first change comes early */

    /* cubic-bezier(.22,1,.36,1): moves off the mark immediately and settles
       softly, so a change never feels like it is winding up. Solved
       numerically so the rAF-driven scroll uses the same curve CSS would. */
    function bezier(x1, y1, x2, y2) {
      function a(p1, p2) { return 1 - 3 * p2 + 3 * p1; }
      function b(p1, p2) { return 3 * p2 - 6 * p1; }
      function c(p1) { return 3 * p1; }
      function at(t, p1, p2) { return ((a(p1, p2) * t + b(p1, p2)) * t + c(p1)) * t; }
      function slope(t, p1, p2) { return 3 * a(p1, p2) * t * t + 2 * b(p1, p2) * t + c(p1); }
      return function (x) {
        if (x <= 0 || x >= 1) return x <= 0 ? 0 : 1;
        var t = x;
        for (var i = 0; i < 8; i++) {
          var dx = at(t, x1, x2) - x, d = slope(t, x1, x2);
          if (Math.abs(dx) < 1e-5 || d === 0) break;
          t -= dx / d;
        }
        return at(Math.min(1, Math.max(0, t)), y1, y2);
      };
    }
    var ease = bezier(0.22, 1, 0.36, 1);

    function init(root) {
      if (root.__promo) return;
      root.__promo = true;
      var track = root.querySelector('[data-promo-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-promo-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-promo-dot]'));
      var pauseBtn = root.querySelector('[data-promo-pause]');
      var prev = root.querySelector('[data-promo-prev]');
      var next = root.querySelector('[data-promo-next]');
      if (!track || slides.length < 2) {
        var ctl = root.querySelector('.promo__controls');
        if (ctl) ctl.hidden = true;
        return;
      }

      var interval = Math.max(3, parseInt(root.getAttribute('data-interval'), 10) || 4) * 1000;
      var firstMove = true;
      var wantsAutoplay = root.getAttribute('data-autoplay') === 'true' && !reduced.matches;
      var userPaused = false, hovering = false, focused = false, visible = true, timer = null, anim = null;

      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }
      function lastIndex() {
        var perView = Math.max(1, Math.round((track.clientWidth + 1) / step()));
        return Math.max(0, slides.length - perView);
      }
      function current() { return Math.round(track.scrollLeft / step()); }

      function stopMove() {
        if (!anim) return;
        cancelAnimationFrame(anim);
        anim = null;
        track.style.scrollSnapType = '';
      }

      function moveTo(left) {
        stopMove();
        var start = track.scrollLeft, dist = left - start;
        if (reduced.matches || Math.abs(dist) < 1) { track.scrollLeft = left; sync(); return; }
        /* Snap points would fight a programmatic scroll mid-flight. */
        track.style.scrollSnapType = 'none';
        var t0 = performance.now();
        function frame(now) {
          var p = Math.min(1, (now - t0) / MOVE_MS);
          track.scrollLeft = start + dist * ease(p);
          if (p < 1) { anim = requestAnimationFrame(frame); }
          else { anim = null; track.style.scrollSnapType = ''; sync(); }
        }
        anim = requestAnimationFrame(frame);
      }

      function go(i) {
        var last = lastIndex();
        if (i > last) i = 0;
        if (i < 0) i = last;
        moveTo(i * step());
        setCurrent(i);
      }

      function setCurrent(i) {
        var last = lastIndex();
        dots.forEach(function (d, k) {
          d.hidden = k > last;
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      function sync() { if (!anim) setCurrent(Math.min(current(), lastIndex())); }

      function running() { return wantsAutoplay && !userPaused && !hovering && !focused && visible && !document.hidden; }
      function tick() {
        clearTimeout(timer);
        if (!running()) { track.setAttribute('aria-live', 'polite'); return; }
        track.setAttribute('aria-live', 'off');
        timer = setTimeout(function () { firstMove = false; go(current() + 1); tick(); }, firstMove ? Math.min(FIRST_MOVE_MS, interval) : interval);
      }

      function setPaused(on) {
        userPaused = on;
        if (!pauseBtn) return;
        pauseBtn.setAttribute('aria-pressed', String(on));
        pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(on ? 'data-label-play' : 'data-label-pause'));
        pauseBtn.querySelector('[data-icon-pause]').hidden = on;
        pauseBtn.querySelector('[data-icon-play]').hidden = !on;
      }

      prev.addEventListener('click', function () { go(current() - 1); tick(); });
      next.addEventListener('click', function () { go(current() + 1); tick(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-promo-dot'), 10)); tick(); });
      });
      if (pauseBtn) {
        if (!wantsAutoplay) pauseBtn.hidden = true;
        pauseBtn.addEventListener('click', function () { setPaused(!userPaused); tick(); });
      }

      /* A person has taken hold of the track: stop any move and stop rotating. */
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (type) {
        track.addEventListener(type, function (e) {
          stopMove();
          if (type !== 'wheel' || Math.abs(e.deltaX) > Math.abs(e.deltaY)) setPaused(true);
          tick();
        }, { passive: true });
      });
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; tick(); } });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; tick(); } });
      root.addEventListener('focusin', function () { focused = true; tick(); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focused = false; tick(); } });
      document.addEventListener('visibilitychange', tick);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; tick(); }, { threshold: 0.4 }).observe(root);
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
      tick();
    }

    function boot(scope) { Array.prototype.forEach.call(scope.querySelectorAll('[data-promo]'), init); }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { boot(document); }) : boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
